/* eslint-disable default-case */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Box from '../../elements/Box';
import BudgetFilter from '../SecondaryFilters/BudgetFilter';
import StayLengthFilter from './StayLengthFilter';
import RateTagsFilter from './RateTagsFilter';
import TravelerInterest from '../SecondaryFilters/TravelerInterest';

const SecondaryFilters = (
  {
    containerSettings,
    containerFiltersSetting,
    availableFilters,
    stayLength,
    stayLengthSettings,
    stayLengthColumnSettings,
    ratesTags,
    rateTagsSettings,
    rateTagsColumnSettings,
    budget,
    budgetSettings,
    budgetColumnSettings,
    travelerInterest,
    travelerInterestSettings,
    travelerInterestColumnSettings
  },
  ref
) => {
  const elementsWrappers = {
    Budget: (e) => (
      <Box key="Budget" marginRight="8px" marginBottom="12px" floatLeft {...budgetColumnSettings}>
        {e}
      </Box>
    ),
    RateTags: (e) => (
      <Box key="RateTags" {...rateTagsColumnSettings}>
        {e}
      </Box>
    ),
    StayLength: (e) => (
      <Box key="StayLength" {...stayLengthColumnSettings}>
        {e}
      </Box>
    ),
    TravelerInterest: (e) => (
      <Box key="TravelerInterest" {...travelerInterestColumnSettings}>
        {e}
      </Box>
    )
  };
  const elements = {
    Budget: <BudgetFilter {...budgetSettings} {...budget} />,
    RateTags: <RateTagsFilter {...rateTagsSettings} {...ratesTags} />,
    StayLength: <StayLengthFilter {...stayLengthSettings} {...stayLength} />,
    TravelerInterest: <TravelerInterest {...travelerInterest} />
  };
  const filtersToDisplay = availableFilters.filter((e) => {
    let iterator = e;
    if (typeof iterator === 'object') {
      iterator = e.type;
    }
    return elements[iterator];
  });

  const firstElementRef = useRef(null);
  const travelerInterestRef = useRef(null);

  React.useImperativeHandle(ref, () => ({
    focusFirstElement: () => {
      setTimeout(() => firstElementRef.current?.focusToggleElement(), 100);
    }
  }));

  return (
    <Box className="fr-secondary-filters" display="flex" {...containerSettings}>
      <Box display="inline-block" {...containerFiltersSetting}>
        {filtersToDisplay.map((ele, index) => {
          let e = ele;
          if (typeof e === 'object') {
            e = e.type;
          }
          const wrapper = elementsWrappers[e];
          const element = wrapper(elements[e]);

          if (e === 'TravelerInterest') {
            const temporalElement = React.cloneElement(elements[e], {
              ...travelerInterestSettings[ele.id],
              ref: travelerInterestRef
            });
            return wrapper(temporalElement);
          }

          return element;
        })}
      </Box>
    </Box>
  );
};

SecondaryFilters.propTypes = {
  showLabels: PropTypes.bool,
  availableFilters: PropTypes.arrayOf(
    PropTypes.oneOf(['Budget', 'RateTags', 'StayLength', PropTypes.objectOf(PropTypes.any)])
  ),
  containerSettings: PropTypes.objectOf(PropTypes.any),
  stayLengthSettings: PropTypes.objectOf(PropTypes.any),
  stayLengthColumnSettings: PropTypes.objectOf(PropTypes.any),
  stayLength: PropTypes.shape({
    defaultValue: PropTypes.string,
    onChange: PropTypes.func
  }),
  rateTagsSettings: PropTypes.objectOf(PropTypes.any),
  rateTagsColumnSettings: PropTypes.objectOf(PropTypes.any),
  rateTags: PropTypes.shape({
    defaultValue: PropTypes.string,
    onChange: PropTypes.func
  })
};

SecondaryFilters.defaultProps = {
  availableFilters: [],
  showLabels: false,
  containerSettings: {},
  stayLengthSettings: {},
  stayLengthColumnSettings: {},
  stayLength: {},
  rateTagsSettings: {},
  rateTagsColumnSettings: {},
  rateTags: {}
};

export default React.forwardRef(SecondaryFilters);
